var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6923 10.1538V10.7692C11.6923 11.279 11.279 11.6923 10.7692 11.6923H6.30769C6.11027 11.7011 5.92172 11.6544 5.75837 11.5652L7.59685 9.71272L10.7231 9.23076H10.7692C11.279 9.23076 11.6923 9.64404 11.6923 10.1538ZM6.69678 7.96972L6.64615 7.6923H7.03077L7.64615 7.07691H6.53846L6.20615 5.19076C6.38256 5.15367 6.53791 5.0501 6.64 4.90153C6.74233 4.72128 6.7874 4.51416 6.76923 4.30768V2.46153C6.75629 1.95718 6.3505 1.55139 5.84615 1.53845H5.23077C4.73156 1.56315 4.33239 1.96232 4.30769 2.46153L4.30804 2.49495C4.31075 2.74061 4.32758 4.26975 4.30769 4.92307C4.29421 5.37236 4.74326 8.02932 5.02256 9.64394L6.69678 7.96972ZM6.49231 14.0554L7.07692 12.3077H7.70769L7.19692 13.8461H10.0492L9.53846 12.3077H10.1692L10.7538 14.0554C10.7848 14.1492 10.7688 14.2523 10.7108 14.3323C10.6533 14.413 10.5606 14.4611 10.4615 14.4615H6.76923C6.67567 14.4563 6.58959 14.4087 6.53538 14.3323C6.47738 14.2523 6.46136 14.1492 6.49231 14.0554Z",
    fill: "#8C8C92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15563 14.1552C2.07384 14.1556 1.99524 14.1235 1.93717 14.0659C1.87892 14.0081 1.84615 13.9295 1.84615 13.8475C1.84615 13.7654 1.87892 13.6868 1.93717 13.629L13.6295 1.93669C13.7075 1.85864 13.8213 1.82816 13.9279 1.85673C14.0345 1.88529 14.1178 1.96857 14.1464 2.07519C14.1749 2.1818 14.1444 2.29556 14.0664 2.37361L2.37409 14.0659C2.31602 14.1235 2.23742 14.1556 2.15563 14.1552Z",
    fill: "#8C8C92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatNotAvailable);
export default __webpack_public_path__ + "static/media/seat_not_available.90c4e90618ff9c478952d9c6c3e02cba.svg";
export { ForwardRef as ReactComponent };